<div class="select-box">
  <label [for]="title" class="title">
    {{ title }}
  </label>
  <select
    [id]="title"
    (change)="onChange($event)"
    [attr.itemSelected]="!!selectedValue && highlightSelectedValues"
  >
    <option value="" selected>{{ placeholder | cxTranslate }}</option>
    <option
      *ngFor="let item of items"
      [value]="item?.code || item"
      [selected]="isSelectedValue(item)"
      [attr.itemSelected]="isSelectedValue(item) && highlightSelectedValues"
    >
      {{ item?.text || item }}
    </option>
  </select>
</div>
